import type { MetaFunction } from 'react-router'
import { STATIC_PAGE_HEADERS } from "~/lib/cache.server"
import { Navbar } from '~/components/navbar'
import { Footer } from '~/components/footer'
import { Handshake, TrendingUp, Euro, Globe, CheckCircle, Mail } from 'lucide-react'

export function headers() { return STATIC_PAGE_HEADERS }

export const meta: MetaFunction = () => [
  { title: 'Programme partenaire — Devenez affilié | AfficheServices' },
  { name: 'description', content: 'Rejoignez le programme partenaire AfficheServices. Gagnez des commissions en recommandant nos services à votre audience.' },
  { tagName: 'link', rel: 'canonical', href: 'https://www.afficheservices.fr/partenaires' },
  { property: 'og:image', content: 'https://www.afficheservices.fr/api/og?title=Programme+partenaire&subtitle=Devenez+affilie' },
]

export default function Partenaires() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="mx-auto max-w-4xl px-4 py-16 lg:px-6">
        <div className="text-center">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10">
            <Handshake className="h-8 w-8 text-primary" />
          </div>
          <h1 className="mt-4 text-3xl font-bold text-slate-900">Programme partenaire</h1>
          <p className="mt-3 text-lg text-slate-500">
            Recommandez AfficheServices et gagnez des commissions sur chaque inscription pro.
          </p>
        </div>

        {/* How it works */}
        <div className="mt-12 grid gap-6 sm:grid-cols-3">
          {[
            { icon: Globe, title: 'Partagez votre lien', desc: 'Intégrez votre lien affilié sur votre site, blog ou réseaux sociaux.', color: 'bg-blue-50 text-blue-600' },
            { icon: TrendingUp, title: 'Générez du trafic', desc: 'Vos visiteurs s\'inscrivent comme particulier ou professionnel.', color: 'bg-amber-50 text-amber-600' },
            { icon: Euro, title: 'Gagnez des commissions', desc: 'Recevez une commission pour chaque pro qui souscrit un abonnement.', color: 'bg-emerald-50 text-emerald-600' },
          ].map((step) => (
            <div key={step.title} className="rounded-xl border border-slate-100 p-6 text-center">
              <div className={`mx-auto flex h-12 w-12 items-center justify-center rounded-xl ${step.color}`}>
                <step.icon className="h-6 w-6" />
              </div>
              <h3 className="mt-4 text-base font-semibold text-slate-900">{step.title}</h3>
              <p className="mt-2 text-sm text-slate-500">{step.desc}</p>
            </div>
          ))}
        </div>

        {/* Benefits */}
        <div className="mt-12 rounded-2xl bg-slate-50 p-8">
          <h2 className="text-xl font-bold text-slate-900">Pourquoi devenir partenaire ?</h2>
          <div className="mt-6 grid gap-4 sm:grid-cols-2">
            {[
              'Commission récurrente sur les abonnements pro',
              'Dashboard de suivi en temps réel',
              'Matériel marketing fourni (bannières, textes)',
              'Paiement mensuel par virement',
              'Support dédié partenaires',
              'Aucun engagement — arrêtez quand vous voulez',
            ].map((item) => (
              <div key={item} className="flex items-start gap-2">
                <CheckCircle className="mt-0.5 h-4 w-4 shrink-0 text-emerald-500" />
                <span className="text-sm text-slate-700">{item}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Who */}
        <div className="mt-12">
          <h2 className="text-xl font-bold text-slate-900">Pour qui ?</h2>
          <div className="mt-6 grid gap-4 sm:grid-cols-3">
            {[
              { title: 'Blogueurs', desc: 'Vous écrivez sur la maison, les travaux ou l\'immobilier.' },
              { title: 'Agents immobiliers', desc: 'Vous accompagnez des acheteurs qui ont besoin de travaux.' },
              { title: 'Influenceurs', desc: 'Votre audience s\'intéresse à la rénovation et la décoration.' },
            ].map((p) => (
              <div key={p.title} className="rounded-xl border border-slate-100 p-5">
                <h3 className="text-sm font-bold text-slate-900">{p.title}</h3>
                <p className="mt-2 text-xs text-slate-500">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="mt-12 rounded-2xl bg-gradient-to-r from-primary to-blue-600 p-8 text-center text-white sm:p-12">
          <h2 className="text-2xl font-bold">Rejoignez le programme</h2>
          <p className="mt-2 text-blue-100">Contactez-nous pour obtenir votre lien affilié et commencer à gagner.</p>
          <a href="mailto:partenaires@afficheservices.fr" className="mt-6 inline-flex items-center gap-2 rounded-xl bg-white px-8 py-3.5 text-sm font-semibold text-primary shadow-md hover:bg-slate-50 btn-press">
            <Mail className="h-4 w-4" /> partenaires@afficheservices.fr
          </a>
        </div>
      </div>
      <Footer />
    </div>
  )
}
